import React from "react";

import { connect } from 'react-redux';
import { fetchStoreDesign } from '../../redux/actions/designAction'

class Design extends React.Component { 
    
    componentWillMount() {
        let storeId = window.sessionStorage.getItem('storeId');
        this.props.fetchStoreDesign(storeId);   
 
    }    

    render() {  
        return (
            <div>
                {this.props.storeDesign &&
                <style>
                    {this.props.storeDesign.cssStyles }
                </style>
                }
            </div>
        );
    }
}
 
  
  const mapStateToProps = (state) =>({
    storeDesign: state.storeSettingData.storeDesign.returnSettingsMap
  });  

export default connect(mapStateToProps, { fetchStoreDesign })(Design);




// WEBPACK FOOTER //
// ./src/components/Common/StoreDesign.js